import firebase, { firestore } from '../../firebase';
import { useEffect, useState } from 'react';

export default function useHasOnHoldAuditsByGroup(groupId: string, orgIds?: string[]) {
  const [audits, setAudits] = useState<any[]>([]);
  const [isLoading, setisLoading] = useState(true);
  useEffect(() => {
    let query = firestore.collectionGroup('auditSchedules');
    let unsubscribe: any = null;
    if (!groupId) return;
    try {
      console.log(groupId);
      query = query
        .where('groupId', '==', groupId)
        .where('isCompleted', '==', true)
        .where('hasOnHoldTasks', '==', true);
      if (orgIds && orgIds?.length > 0) {
        query = query.where('orgId', 'in', orgIds);
      }

      query = query.orderBy('dueDate', 'desc').limit(100);

      unsubscribe = query.onSnapshot(
        (query) => {
          if (!query.empty) {
            const list: any[] = query.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
              orgId: doc.ref.parent.parent?.id,
            }));
            setAudits(list);
          } else {
            setAudits([]);
          }
          setisLoading(false);
        },
        (error) => {
          console.error(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
    return unsubscribe;
  }, [groupId, orgIds]);

  return { audits, isLoading };
}
